import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16274202"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "status p-mt-2" }
const _hoisted_2 = { class: "p-mt-2" }
const _hoisted_3 = { class: "p-d-flex p-ai-center" }
const _hoisted_4 = { class: "p-ml-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle blink" }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "p-mt-2" }
const _hoisted_8 = { class: "p-mt-2" }
const _hoisted_9 = { class: "p-d-flex p-ai-center" }
const _hoisted_10 = { class: "p-ml-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-exclamation-triangle blink" }, null, -1))
const _hoisted_12 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Panel = _resolveComponent("Panel")!
  const _component_PeriodicUpdate = _resolveComponent("PeriodicUpdate")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PeriodicUpdate, {
      path: "/api/status",
      onUpdate: _ctx.onUpdate
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Panel, { header: "Hardware-ID" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("b", null, _toDisplayString(_ctx.hwid === null ? "not available" : _ctx.hwid), 1),
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6)), [
                  [_vShow, !_ctx.hwid_ok],
                  [_directive_tooltip, 'Could not read license dongle.']
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_Panel, { header: "Uptime" }, {
            default: _withCtx(() => [
              _createElementVNode("b", null, _toDisplayString(_ctx.prettyDuration(_ctx.uptime)), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Panel, { header: "Clients" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("b", null, _toDisplayString(_ctx.prettyClients()), 1),
                _withDirectives(_createElementVNode("div", _hoisted_10, _hoisted_12, 512), [
                  [_vShow, _ctx.clients_error]
                ])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onUpdate"])
  ]))
}